/** Desenvolvido by Urnau */
console.info("'uutils-email-validator' carregado com sucesso");

    window.uutils = window.uutils || {};

    const fn_load_validacao_de_emails = () => {
        // Início - Utilize suas credenciais cadastradas na origem registradas no SafetyMails.
        const safetymails_ticket = 'a7fa14306941cf007658616ffa4ca6a06fecbfb0';
        const safetymails_api_key = 'c9783c4c3b51feb30ed1284e1c283f30aceccc0b';
        // Fim - Utilize suas credenciais cadastradas na origem registradas no SafetyMails.

        // Início - Utilize suas credenciais cadastradas na origem registradas no Debounce.io.
        const debounce_api_key = 'public_SzFrUHhub0FadlVoVlZsK0hYUFYxQT09';
        // Fim - Utilize suas credenciais cadastradas na origem registradas no Debounce.io.

        const controle = {
            safetymails_active: false,
            debounce_active: true
        }

        const msg_error_validation_default = "Será que este e-mail está correto? Por favor verifique-o.";

        const list_emails_to_ignore = [
            "10minutemail.com",
            "24hourmail.com",
            "airmail.cc",
            "anonymous.com",
            "boun.cr",
            "brfree.com.br",
            "byom.de",
            "correo.blog",
            "cosmorph.com",
            "discard.email",
            "discardmail.com",
            "dispostable.com",
            "drmail.in",
            "edu.br",
            "email.com.br",
            "email.com",
            "emailfake.com",
            "emailsa.com",
            "emailtemporario.com.br",
            "emailtemporario.com",
            "emaily.pro",
            "example.com",
            "fakeemail.com.br",
            "fakeemail.com",
            "fakeinbox.com",
            "fakemailgenerator.com",
            "getnada.com",
            "gov.br",
            "grr.la",
            "guerrillamail.com",
            "hottempmail.com",
            "inddweg.com",
            "letterhaven.net",
            "mail-temp.com",
            "mail1a.de",
            "mailcatch.com",
            "maildrop.cc",
            "mailfacil.com",
            "mailforspam.com",
            "mailinator.com",
            "mailmetrash.com",
            "mailnesia.com",
            "mailsac.com",
            "makroyal.com",
            "meltmail.com",
            "mintemail.com",
            "moakt.com",
            "mytemp.email",
            "noemail.com",
            "privaterelay.appleid.com",
            "sharklasers.com",
            "spam4.me",
            "spamavert.com",
            "spambox.us",
            "teleworm.us",
            "temp-mail.org",
            "tempail.com",
            "tempmail.dev",
            "tempomail.com.br",
            "temporarymail.com.br",
            "test.com.br",
            "test.com",
            "teste.com.br",
            "teste.com",
            "testing.com",
            "throwawaymail.com",
            "tmail.ws",
            "tmpmail.com",
            "tmpmail.net",
            "trash-mail.com",
            "trashmail.com.br",
            "ufac.br",
            "ufal.br",
            "ufam.edu.br",
            "ufba.br",
            "ufc.br",
            "ufcg.edu.br",
            "ufersa.edu.br",
            "ufg.br",
            "ufma.br",
            "ufmg.br",
            "ufms.br",
            "ufmt.br",
            "ufpa.br",
            "ufpb.br",
            "ufpe.br",
            "ufpel.edu.br",
            "ufpi.br",
            "ufpr.br",
            "ufrgs.br",
            "ufrj.br",
            "ufrn.br",
            "ufrpe.br",
            "ufrr.br",
            "ufs.br",
            "ufsc.br",
            "ufsm.br",
            "uft.edu.br",
            "unb.br",
            "unesp.br",
            "unicamp.br",
            "unifap.br",
            "unifesp.br",
            "unilab.edu.br",
            "unipampa.edu.br",
            "unir.br",
            "univasf.edu.br",
            "uol.com.br",
            "uorak.com",
            "usp.br",
            "yomail.info",
            "yopmail.com",
            "zohomail.com.br"
        ];

        const list_start_emails_to_ignore = [
            '1234',
            '12345',
            '123456',
            'abc',
            'atendimento',
            'contact',
            'contato',
            'exemple',
            'exemplo',
            'faleconosco',
            'help',
            'info',
            'loja',
            'noreply',
            'sac',
            'seguro',
            'seguradora',
            'suporte',
            'support',
            'test',
            'teste',
            'web',
            'webmaster'
        ];

        const list_prefix_domains_to_ignore = [
            "gov.br",
            "edu.br"
        ];

        const list_prefix_domains_start_with_to_ignore = [
            "poplk.",
            "uai.",
            "ymail."
        ];

        const list_emails_end_with_domains_incorrects = [
            "gmai.com", "gmai.coml", "gmail.c", "gmail.cim", "gmail.co", "gmail.col", "gmail.com968414", "gmail.coma", "gmail.come", "gmail.comf", "gmail.comh", "gmail.comj", "gmail.coml", "gmail.comm", "gmail.comn", "gmail.comp", "gmail.comr", "gmail.coms", "gmail.con", "gmail.coom", "gmail.cpm", "gmail.fom", "gmail.vom", "gmail.xom",
            "hotkail.com", "hotmail.cim", "hotmail.comk", "hotmail.coml", "hotmail.comm", "hotmail.comn", "hotmail.comp", "hotmail.comr", "hotmail.comt", "hotmail.con", "hotmail.vom", "hotmail.xom",
            "terra.com.brv", "terra.combr", "yahoo.com.r"
        ];

        async function sha1(text) {
            const encoder = new TextEncoder();
            const data = encoder.encode(text);
            const hashBuffer = await crypto.subtle.digest("SHA-1", data);
            return [...new Uint8Array(hashBuffer)]
                .map(byte => byte.toString(16).padStart(2, "0"))
                .join("");
        }

        async function hmacSHA256(value, key) {
            const encoder = new TextEncoder();
            const keyData = encoder.encode(key);
            const valueData = encoder.encode(value);

            const cryptoKey = await crypto.subtle.importKey(
                "raw", keyData, { name: "HMAC", hash: { name: "SHA-256" } }, false, ["sign"]
            );
            const signature = await crypto.subtle.sign("HMAC", cryptoKey, valueData);
            return [...new Uint8Array(signature)]
                .map(byte => byte.toString(16).padStart(2, "0"))
                .join("");
        }

        const fn_email_validator = async (email) => {
            if (email.length < 6) {
                // @role Quando usuário preenche um e-mail com menos de 6 caracteres.
                // throw new Error("Você deve preencher corretamente o campo e-mail.");
                throw new Error(msg_error_validation_default || "Você deve preencher corretamente o campo e-mail.");
            }

            // Validar o formato do e-mail antes de prosseguir
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(email)) {
                // @role Quando usuário preenche um e-mail totalmente inválido (ex: meu_qualquer.coisa, nadaadeclarar, etc)
                throw new Error(msg_error_validation_default || "Formato de e-mail inválido. Por favor, insira um e-mail válido.");
            }

            if (list_emails_end_with_domains_incorrects.some(sufixo => email.toLowerCase().endsWith(`@${sufixo}`))) {
                // @role Quando o domínio está possívelmente escrito errado.
                throw new Error(msg_error_validation_default || "Domínio de e-mail possivelmente incorreto. Verifique o e-mail informado e tente novamente.");
            }

            if (list_emails_to_ignore.some(sufixo => email.toLowerCase().endsWith(`@${sufixo}`))) {
                // @role Quando o domínio do e-mail está na nossa lista negra (ex: @teste.com, @anonymous.com )
                throw new Error(msg_error_validation_default || "Domínio de e-mail não permitido. Utilize um novo e-mail válido, sugerimos que utilize um e-mail pessoal.");
            }

            if (list_start_emails_to_ignore.some(prefixo => email.toLowerCase().startsWith(`${prefixo}@`))) {
                // @role Quando termo antes do @ está na nossa lista negra (ex: teste, sac )
                throw new Error(msg_error_validation_default || "E-mail não permitido. Utilize um novo e-mail válido, sugerimos que utilize um e-mail pessoal.");
            }

            const domain = email.split('@')[1];
            if (list_prefix_domains_to_ignore.some(prefixo => domain.toLowerCase().endsWith(`.${prefixo}`))) {
                // @role Quando o término do domínio do e-mail está na nossa lista negra (ex: gov.br, edu.br )
                throw new Error(msg_error_validation_default || "Extensão do domínio de e-mail não permitido. Utilize um novo e-mail válido, sugerimos que utilize um e-mail pessoal.");
            }

            if (list_prefix_domains_start_with_to_ignore.some(prefixo => domain.toLowerCase().startsWith(prefixo))) {
                // @role Quando o início do domínio do e-mail está na nossa lista negra (ex: poplk, uai, ymail )
                throw new Error(msg_error_validation_default || "E-mail contem domínio não permitido. Utilize um novo e-mail válido, sugerimos que utilize um e-mail pessoal.");
            }

            console.debug("Utilizando fluxo central de validação de e-mails", { controle });

            // Faz a validação do e-mail no safetymails, em caso de erro, o catch irá tratar o erro e retornar uma exceção.
            if (controle.safetymails_active) {
                await fn_validator_safetymails(email);
            }
            if (controle.debounce_active) {
                await fn_validator_debounce(email);
            }

            if (!controle.safetymails_active && !controle.debounce_active) {
                console.warn("Nenhum serviço de validação de e-mail ativo. O e-mail será aceito sem validações extras.");
            }
        };

        const fn_validator_safetymails = async (email) => {
            const code = await sha1(safetymails_ticket);
            const url = `https://${safetymails_ticket}.safetymails.com/api/${code}`;
            const hmac = await hmacSHA256(email, safetymails_api_key);

            let form = new FormData();
            form.append('email', email);

            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: { "Sf-Hmac": hmac },
                    body: form
                });

                if (!response.ok) {
                    console.error(`HTTPCode ${response.status}`);
                    // @role Quando o safetymail retorna algum erro desconhecido
                    throw new Error(msg_error_validation_default || "Erro ao realizar a validação do e-mail.");
                }

                const data = await response.json();

                if (!data.Success) {
                    console.error("Response error", data);
                    // @role Quando o safetymail retorna dizendo que o e-mail é inválido
                    throw new Error(msg_error_validation_default || "E-mail inválido ou não permitido. Confira o e-mail informado ou utilize um novo.");
                }

                let status = (data?.Status || '').toUpperCase();
                if (status === "INVALIDO" || status === "INVALID" || status === "ERRO_SINTAXE") {
                    // @role Quando o safetymail recusa apenas o e-mail
                    throw new Error(msg_error_validation_default || "E-mail recusado. Confira o e-mail informado ou utilize um novo.");
                }

                let domainStatus = (data?.DomainStatus || '').toUpperCase(); // Update to use domainStatus
                if (domainStatus === "INVALIDO" || domainStatus === "INVALID") {
                    // @role Quando o safetymail emite um alerta de advertencia sobre o e-mail
                    throw new Error(msg_error_validation_default || "Domínio de e-mail recusado. Utilize um novo e-mail válido.");
                }

                let advice = (data?.Advice || '').toUpperCase(); // Update to use domainStatus
                if (advice === "INVALIDO" || advice === "INVALID") { // Fixed condition to check advice
                    // @role Quando o safetymail emite um alerta de advertencia sobre o e-mail
                    throw new Error(msg_error_validation_default || "Domínio de e-mail recusado. Utilize um novo e-mail válido.");
                }

                console.log("Response success", data);
                return;
            } catch (error) {
                console.error("Request failed", error);
                // @role Quando o código de validação de e-mail dá um erro não esperado na programação.
                throw new Error(error.message || msg_error_validation_default || "Erro desconhecido ao realizar a validação do e-mail.");
            }
        }

        const fn_validator_debounce = async (email) => {
            try {
                const response = await fetch(`https://api.debounce.io/v1/?api=${debounce_api_key}&email=${email}`);
                const data = await response.json();

                if (data.success) {
                    const result = data.debounce;
                    if (result.result === "Safe to Send" && result.free_email == 'true') {
                        return;
                    } else {
                        console.warn("E-mail inválido ou de risco 🚨", result);
                        throw new Error(msg_error_validation_default || "O e-mail digitado pode ser inválido. Tente outro.");
                    }
                } else {
                    console.error("Erro na validação do e-mail:", data);
                    throw new Error(msg_error_validation_default || "Erro na validação do e-mail.");
                }
            } catch (error) {
                console.error("Erro ao conectar à API da Debounce.io:", error);
                throw new Error(error.message || msg_error_validation_default || "Erro ao conectar à API da Debounce.io.");
            }
        };

        window.uutils.email_validator = fn_email_validator
    };


    fn_load_validacao_de_emails();
